export const buttonSelectedStyle = {
  backgroundColor: 'electricBlue.main',
  '&:hover': {
    backgroundColor: 'navyBlue.main',
  },
  '&:active': {
    backgroundColor: 'neutral100.main',
  },
};

export const buttonDefaultStyle = {
  borderColor: 'electricBlue.main',
  color: 'electricBlue.main',
  '&:hover': {
    backgroundColor: 'borderGrayLight.main',
  },
  '&:active': {
    backgroundColor: 'borderGrayLight.main',
    borderColor: 'electricBlue.main',
  },
};

export const chipDefaultStyle = {
  fontSize: '12px',

  '&:hover': {
    backgroundColor: 'hoverState.main',
  },
};

export const chipSelectedStyle = {
  backgroundColor: 'electricBlue.main',
  '&:hover': {
    backgroundColor: 'navyBlue.main',
  },
};
